import NewProfile from "./NewProfile";

export default NewProfile;